import { AbstractComponent } from '../../types/lux'
import { mvc } from './BuildingBlock'
import Dep from './Dep'
import Stateful from './Stateful'
import View from './View'

export default AbstractComponent

/** @nocollapse */
AbstractComponent.mvc = function(el, opts) {
  /** @suppress {checkTypes} */
  const res = mvc(this, el, opts)
  return /** @type {!AbstractComponent} */ (res)
}

/** @constructor @extends {AbstractComponent} @suppress {checkTypes} */ function _AbstractComponent() {}
AbstractComponent.__implement(View,Stateful,Dep,
  _AbstractComponent.prototype = /** @type {!AbstractComponent} */ ({
    get model() {
      const{asIStateful:{state}}=this
      return state
    },
    initialiser({props,classes,state}={}) {
      const{superStateful,superView}=this
      superView.initialiser({props,classes})
      superStateful.initialiser({state})
      return this
    },
  }),
)